
import React from 'react'
import { useSelector } from 'react-redux'
import styles from './DailyReportCard.module.css'
import { RootState, ReportType } from '../../store/dailyReport/types'
import { Quote } from '../quote/Quote'
import { PlaceHolder } from '../placeHolder/PlaceHolder'
import { RenderDate } from '../date/Date'
import { Report } from '../report/Report'
import { Avatar } from '../avatar/Avatar'

interface Iprops {
  date: string,
  style?: any
}

export const DailyReportCard: React.FC<Iprops> = (props) => {
  const reportItem: ReportType = useSelector((state: RootState) => state.dailyReport.reports).filter(report => report.report_date === props.date)[0]
  const {
    report_date, report, quote, quote_source
  } = reportItem
  const { style } = props
  let cls = ''
  if (report) {
    cls = 'reportContainerFlex'
  }
  return (
    <div className={[styles.reportContainer, styles[`${cls}`]].join(' ')} style={style}>
      <div className={styles.quoteContainer}>
        <div className={styles.dateAvatarWrap}>
          <RenderDate date={report_date} />
          <Avatar />
        </div>
        <Quote quote={quote} quoteSource={quote_source} key={quote} />
      </div>
      {
        report ? <Report reportContent={report} /> : <PlaceHolder />
      }
    </div>
  )
}
